export { default as Img200 } from './processed/200/Battles-BC.jpg';
export { default as Img400 } from './processed/400/Battles-BC.jpg';
export { default as Imgthumb } from './processed/thumb/Battles-BC.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Battles-BC.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Battles-BC.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      68,
      153,
      175
    ],
    "_population": 1931,
    "_hsl": [
      0.5342679127725857,
      0.44032921810699593,
      0.4764705882352941
    ]
  },
  "LightVibrant": {
    "_rgb": [
      155,
      212,
      228
    ],
    "_population": 134,
    "_hsl": [
      0.5365296803652968,
      0.5748031496062993,
      0.7509803921568627
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      24,
      88,
      115
    ],
    "_population": 1925,
    "_hsl": [
      0.5494505494505494,
      0.6546762589928057,
      0.27254901960784317
    ]
  },
  "Muted": {
    "_rgb": [
      94,
      163,
      177
    ],
    "_population": 875,
    "_hsl": [
      0.5281124497991968,
      0.34728033472803344,
      0.5313725490196078
    ]
  },
  "LightMuted": {
    "_rgb": [
      184,
      194,
      191
    ],
    "_population": 386,
    "_hsl": [
      0.4500000000000002,
      0.07575757575757569,
      0.7411764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      58,
      99,
      112
    ],
    "_population": 2137,
    "_hsl": [
      0.5401234567901234,
      0.31764705882352945,
      0.3333333333333333
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Battles-BC.js